$(document).ready(function () {
  if (!window.matchMedia("(max-width: 767px)").matches) {
    // URL Function
    var urlCat = decodeURI(getParameterByName("cat"));
    var urlName = decodeURI(getParameterByName("name"));
    var urlParent = getParameterByName("parent") || 0;

    if (urlCat != "" && urlParent != "") {
      console.log("URL not Empty");
      if (urlParent != "" && urlCat != "" && urlName != "") {
        $(".desktop-list .get-faq-post").removeClass("active");
        $(".get-faq-post[data-cid=" + urlParent + "]").addClass("active");
        get_faq_posts($(".get-faq-post[data-cid=" + urlParent + "]").data("cid"));
      }
    } else {
      console.log("URL Empty");
      // $('.desktop-list .get-faq-post:first-of-type').trigger('click');
    }
  }

  // Load needed aJax functions
  $(window).on("load", function () {
    if (!window.matchMedia("(max-width: 767px)").matches) {
      // DESKTOP
      setTimeout(function () {
        // console.log('Times up!');
        if (urlName != "") {
          console.log("URL not Empty - On Load");
          var currIndex = $(".get-faq-post[data-name=" + urlName + "]").index();

          if (currIndex == -1 || currIndex == 0) {
            // $('.subcategories').has('.subcategory-list').find('li:first-of-type').trigger('click');
          } else {
            $(".subcategory-list").find("li").removeClass("active");
            $(".get-faq-post[data-name=" + urlName + "]").addClass("active");
            get_faq_posts($(".get-faq-post[data-name=" + urlName + "]").data("cid"));
          }
        } else {
          console.log("URL Empty - On Load");
        }
      }, 1000);

      setTimeout(function () {}, 1500);
    }

    $(".faq-banner .get-faq-post").each(function () {});
  });

  // FAQ
  $("body").on("click", ".get-faq-post .content", function (e) {
    e.stopPropagation();
  });

  $("body").on("click", ".get-faq-post", function (e) {
    // console.log('Click');
    e.preventDefault();
    var $this = $(this),
      cid = $this.data("cid"),
      title = $this.data("title"),
      name = $this.data("name"),
      parent = $this.data("parent") || 0;

    // pushWindowState(title, {
    //   cat: title.replace(/\s/g, "-"),
    //   name: name,
    //   parent: parent,
    // });

    // FOR MOBILE TAB
    if (window.matchMedia("(max-width: 767px)").matches) {
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $this.find(".faq-lists").slideUp();
      } else {
        $(".mobile-list .get-faq-post").removeClass("active");
        $this.addClass("active");

        $(".mobile-list .get-faq-post > .faq-lists").slideUp();
        $this.find(".faq-lists").slideDown();

        get_faq_posts(cid);
      }
    } else {
      /*FOR DESKTOP*/
      if (!$this.hasClass("active")) {
        if (cid == 2 || cid == 3 || cid == 4 || cid == 5 || cid == 34) {
          // $('.desktop-list .get-faq-post').removeClass('active');
        }

        if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
          $(".desktop-list .get-faq-post").removeClass("active");
        }

        $this.closest(".subcategory-list").find("li").removeClass("active");
        $this.addClass("active");

        if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
          $(".default-page .content .title").text(title);
        }

        if (cid == 2 || cid == 3 || cid == 4 || cid == 5 || cid == 34) {
          // $('.default-page .content .title').text(title);
        }

        get_faq_posts(cid);
      }
    }
  });

  $("body").on("submit", ".faq-search", function (e) {
    e.preventDefault();
    var $this = $(this),
      s = $this.find("input[name=s]").val();

    $(".default-page .content .cat-title").text("search results");
    $(".subcategories").html("");
    $(".mobile-subcategories").html("");
    $(".item.get-faq-post").removeClass("active");

    search_faq_posts(s);
  });
});

var ajax_faq_posts;
// Ajax Functions Here
function get_faq_posts(cid) {
  if (ajax_faq_posts != null) {
    ajax_faq_posts.abort();
  }

  ajax_faq_posts = $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "get_faq_posts",
      cid: cid,
    },
    beforeSend: function () {
      // console.log('Getting FAQ posts...');
    },
    success: function (resp) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        // console.log('mobile list');
        // MOBILE
        $(".default-page .content .lists.desktop-lists .content").html("");
        $(".mobile-search-wrapper.lists .content").html(resp.data);
      } else {
        // console.log('desktop list');
        // DESKTOP
        $(".default-page .content .lists.desktop-lists .content").html(resp.data);
        $(".mobile-search-wrapper.lists .content").html("");
      }

      //console.log(cid);

      if (window.matchMedia("(max-width: 767px)").matches) {
        /*FOR MOBILE*/
        var pagination_container = $(".mobile-search-wrapper.lists .paginate");
      } else {
        /*FOR DESKTOP*/
        var pagination_container = $(".default-page .content .lists .paginate");
      }

      // if (cid == 2 || cid == 3 || cid == 4 || cid == 5 || cid == 34) {
      //    $('.default-page .content .title').text(title);
      // }

      make_paginate(pagination_container, resp.action, cid, resp.page, resp.totalPages);
      // $('.result-count').html("Page "+resp.page+" of "+resp.totalPages);
      $(pagination_container)
        .find(".result-count")
        .html("Page " + resp.page + " of " + resp.totalPages);

      // console.log(resp);

      customAccordionTweaks();
    },
  });

  if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
    // console.log("New Check Successful");
    if (window.matchMedia("(max-width: 767px)").matches) {
      get_faq_subcategories_select(cid);
    } else {
      get_faq_subcategories(cid);
    }
  } else {
    // console.log("New Check Failed");
  }
}

var ajax_faq_subcategories = null;
function get_faq_subcategories(cid) {
  if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
    $(".subcategories").html("");
  }

  if (ajax_faq_subcategories != null) {
    ajax_faq_subcategories.abort();
  }

  ajax_faq_subcategories = $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "get_faq_subcategories",
      cid: cid,
    },
    beforeSend: function () {
      // console.log('Getting subcategories...');
    },
    success: function (resp) {
      $(".subcategories").html(resp.data);

      if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
        var count = $(".subcategories").has(".subcategory-list").length;

        if (getParameterByName("parent") == 0 || count != 0) {
          // console.log('Present');
          $(".subcategories").has(".subcategory-list").find("li:first-of-type").trigger("click");
        } else {
          // console.log('Not Present');
        }
      }
    },
  });
}

var ajax_faq_subcategories_select;
function get_faq_subcategories_select(cid) {
  if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
    $(".mobile-subcategories").html("");
  }

  if (ajax_faq_subcategories_select != null) {
    ajax_faq_subcategories_select.abort();
  }

  ajax_faq_subcategories_select = $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "get_faq_subcategories_select",
      cid: cid,
    },
    beforeSend: function () {
      // console.log('Getting mobile subcategories...');
    },
    success: function (resp) {
      $(".mobile-subcategories").html(resp.data);

      mobileSelectSubcategories();

      var selected = $("#mobileSelectSubcategories").find(":selected");

      var cid = selected.val();
      //var title  = selected.data('title');
      //var name   = selected.data('name');
      //var parent = selected.data('parent') || 0;

      // window.history.pushState(null, title, "?cat="+title.replace(/\s/g,"-")+"&name="+name+"&parent="+parent);
      if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
        get_faq_posts(cid);
      }
    },
  });
}

function search_faq_posts(s) {
  $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "search_faq_posts",
      s: s,
    },
    success: function (resp) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        // MOBILE
        $(".mobile-search-wrapper .content").html(resp.data);
        $(".default-page .content .lists.desktop-lists .content").html("");
      } else {
        // DESKTOP
        $(".default-page .content .lists.desktop-lists .content").html(resp.data);
        $(".mobile-search-wrapper .content").html("");
      }

      var pagination_container = $(".mobile-search-wrapper .paginate, .default-page .content .lists.desktop-lists .paginate");

      make_paginate(pagination_container, resp.action, s, resp.page, resp.totalPages);
      // $('.result-count').html("Page "+resp.page+" of "+resp.totalPages);
      $(pagination_container)
        .find(".result-count")
        .html("Page " + resp.page + " of " + resp.totalPages);

      customAccordionTweaks();
    },
  });
}

// TESTING
// MOBILE LAYOUT FUNCTIONS

$(document).ready(function () {
  var urlCat = decodeURI(getParameterByName("cat"));
  var urlName = decodeURI(getParameterByName("name"));
  var urlParent = getParameterByName("parent") || 0;

  // console.log('parent: ' + urlParent);

  $(window).on("load", function () {
    if (urlParent != 0) {
      console.log("is subcategory");
      $("#mobileSelect option[value=" + urlParent + "]").attr("selected", "selected");
      $("#mobileSelect").trigger("change");

      var onLoadTitle = decodeURI($("#mobileSelect option[value=" + urlParent + "]").data("title"));

      $(".default-page .content .cat-title").text(onLoadTitle);

      setTimeout(function () {
        console.log("Timer!");

        $("#mobileSelectSubcategories option[data-name=" + urlName + "]").attr("selected", "selected");
        $("#mobileSelectSubcategories").trigger("change");
      }, 1000);

      // get_faq_subcategories_select(urlParent);
    } else {
      // console.log('is category');
      if (urlName != "") {
        console.log("success");
        $("#mobileSelect option[data-name=" + urlName + "]").attr("selected", "selected");
        $("#mobileSelect").trigger("change");
      } else {
        console.log("fail");
      }
    }
  });
});

$(window).on("load", function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    // VARS
    var onLoadTitle = $("#mobileSelect").find(":selected").data("title");
    var cid = $("#mobileSelect").find(":selected").data("cid");

    // LIST TITLE
    if ($(".default-page .content .cat-title").text() == "") {
      $(".default-page .content .cat-title").text(onLoadTitle);
    }

    var subcategories = $(".mobile-subcategories select").length;

    if (subcategories != 0) {
      console.log("Trigger first of type");
      var selected = $("#mobileSelectSubcategories").find(":selected");

      var cid = selected.val();
      var title = selected.data("title");
      var name = selected.data("name");
      var parent = selected.data("parent") || 0;

      // pushWindowState(title, {
      //   cat: title.replace(/\s/g, "-"),
      //   name: name,
      //   parent: parent,
      // });

      get_faq_posts(cid);
    } else {
      // console.log('Trigger subcategories');
      // TRIGGER SUBCATEGORIES
      get_faq_subcategories_select(cid);
    }
  }
});

$("#mobileSelect").on("change", function () {
  console.log("Mobile categories changed...");
  var selected = $(this).find(":selected");

  var cid = selected.val();
  var title = selected.data("title");
  var name = selected.data("name");
  var parent = selected.data("parent") || 0;

  if (cid == 2 || cid == 3 || cid == 4 || cid == 5 || cid == 34) {
    // $('.default-page .content .cat-title').text(decodeURI(title));
  }

  if ($("*[data-cid=" + cid + "]").data("class") == "is_parent") {
    $(".default-page .content .cat-title").text(decodeURI(title));
  }

  // pushWindowState(title, {
  //   cat: title.replace(/\s/g, "-"),
  //   name: name,
  //   parent: parent,
  // });

  get_faq_subcategories_select(cid);

  get_faq_posts(cid);
});

function mobileSelectSubcategories() {
  $("#mobileSelectSubcategories").on("change", function () {
    console.log("Mobile subcategories changed...");
    var selected = $(this).find(":selected");

    var cid = selected.val();
    var title = selected.data("title");
    var name = selected.data("name");
    var parent = selected.data("parent") || 0;

    // pushWindowState(title, {
    //   cat: title.replace(/\s/g, "-"),
    //   name: name,
    //   parent: parent,
    // });

    get_faq_posts(cid);
  });
}

function customAccordionTweaks() {
  $("a.cstm-trigger").on("click", function () {
    $(".collapse").each(function () {
      $(this).collapse("hide");
    });
  });

  $(".collapse").on("shown.bs.collapse", function (e) {
    var $card = $(this).parent().prev();
    var additionalOffset = 0;

    if ($card.length === 0) {
      $card = $(this).parent();
      additionalOffset = 60;
    }

    $("html,body").animate(
      {
        scrollTop: $card.offset().top - additionalOffset,
      },
      500
    );
  });
}

function doneResize() {
  if ($(".faq-banner").length) {
    //Verifying we are on the faq page
    var recalcfaq = false;
    if (window.matchMedia("(max-width: 767px)").matches && is_mobile === false) {
      is_mobile = true;
      recalcfaq = true;
      // LIST TITLE
      if ($(".default-page .content .cat-title").text() == "") {
        var onLoadTitle = $("#mobileSelect").find(":selected").data("title");
        $(".default-page .content .cat-title").text(onLoadTitle);
      }
    } else if (!window.matchMedia("(max-width: 767px)").matches && is_mobile === true) {
      is_mobile = false;
      recalcfaq = true;
    }
    if (recalcfaq === true) {
      console.log("REcalc due toe sizing event");
      $(".default-page .content .lists .title").text($(".get-faq-post.active").data("title"));
      get_faq_posts($(".get-faq-post.active").data("cid"));
    }
  }
}

var resize_check;
$(window).resize(function () {
  clearTimeout(resize_check);
  resize_check = setTimeout(doneResize, 500);
});

customAccordionTweaks();
